var pug = require("!../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;pug_html = pug_html + "\u003Cdiv id=\"ddis_index\"\u003E\u003CddisTable :ddis=\"ddis\" :meta=\"meta\" @load-data=\"loadSmsTemplates\"\u003E\u003C\u002FddisTable\u003E\u003C\u002Fdiv\u003E";;return pug_html;};
module.exports = template;